import { PayableHistory } from 'components/PayableHistory'
import { useCallback } from 'react'
import { getContractorPayments } from 'services/apis/loan/contractor'

/** Everything paid to this contractor, across every loan. */
export const ContractorPaymentSection = ({ contractorNo }: { contractorNo: number }) => {
  const load = useCallback(() => getContractorPayments(contractorNo), [contractorNo])
  return <PayableHistory title="Contractor History" load={load} />
}
